import { render, staticRenderFns } from "./ComunicationPreferences.vue?vue&type=template&id=10ca5d96&scoped=true&lang=pug&"
import script from "./ComunicationPreferences.vue?vue&type=script&lang=js&"
export * from "./ComunicationPreferences.vue?vue&type=script&lang=js&"
import style0 from "./ComunicationPreferences.vue?vue&type=style&index=0&id=10ca5d96&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ca5d96",
  null
  
)

export default component.exports